import { ComboboxData, Group, Stack } from "@mantine/core"
import { Loader, Select } from "@tfg/ui"
import { useEffect, useState } from "react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { EditableCellWithTextInput } from "~/pages/Admin/Translations/columns.tsx"
import { filterDeletedAtSelectOptions } from "~/pages/Brand/OrganizationSettings/Mapping/components/MappingSelect.tsx"
import {
  useListMaterialTypesQuery,
  useUpdateMaterialMutation,
} from "~/pages/Brand/Products/Details/hooks.ts"

type Props = {
  material: LibraryResponses.EnrichedMaterial
}

export function MaterialPropertySelection({ material }: Props) {
  const { data: materialTypeList, isLoading } = useListMaterialTypesQuery(
    material.type.materialOpChain
  )
  const [selectOptions, setSelectOptions] = useState<ComboboxData>([])
  const { mutate: updateMaterial } = useUpdateMaterialMutation()

  useEffect(() => {
    setSelectOptions(
      filterDeletedAtSelectOptions(materialTypeList, material.type.id)
    )
  }, [material, materialTypeList])

  if (isLoading) {
    return <Loader fullPage />
  } else {
    return (
      <Stack gap="xs" align="flex-start">
        <Group justify="space-between" w="100%" wrap="nowrap">
          <Select
            value={material.type.id.toString()}
            data={selectOptions}
            onChange={(newValue) =>
              updateMaterial({
                id: material.id,
                typeId: materialTypeList?.find(
                  (materialType) => materialType.id === Number(newValue)
                )?.id,
              })
            }
            searchable
            clearable
          />
          <EditableCellWithTextInput
            defaultValue={material.proportion.toString()}
            onSave={(newValue: string) =>
              updateMaterial({
                id: material.id,
                proportion: parseInt(newValue),
              })
            }
          />
        </Group>
      </Stack>
    )
  }
}
